import React,{useEffect,useState} from "react";
import {useNavigate,useSearchParams} from "react-router-dom";
import {Container,Spinner, Button} from "react-bootstrap";

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const orderNo = params.get("order_no");

  return (
    <Container className="text-center py-5">
      <h2 className="text-success">✓ Payment Successful</h2>
      <p>Your payment has been completed successfully.</p>
      {orderNo && <p><b>Order No:</b> {orderNo}</p>}
      <Button onClick={() => navigate("/")}>
        Continue Shopping
      </Button>
    </Container>
  );
};

export default PaymentSuccess;